var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 36 14.81" }, props),
    React.createElement("path", { fill: "none", stroke: "#306f82", strokeMiterlimit: "10", strokeWidth: "2", d: "M11.94 7.43L36 7.33" }),
    React.createElement("path", { fill: "#306f82", d: "M17.59 14.81l-3.18-7.39L17.53 0 0 7.48l17.59 7.33z" })
  );
});